import React, { useEffect } from 'react';
import { Form, Space } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setJobTemplatePayload } from 'redux/jobs/jobTemplates/slice';
import { getJobTemplateConfigSelector } from 'redux/jobs/jobTemplates/selectors';
import { cleanObject } from 'utils/dataUtils';
import useWindowAutoScroll from 'hooks/useWindowAutoScroll';
import { isEmpty } from 'lodash-es';
import TableToggle from '../../TableToggle';

const JobRequirementSkillsForm = ({ form, initTemplate }) => {
  useWindowAutoScroll();
  const dispatch = useDispatch();

  const { skills = [] } = useSelector(getJobTemplateConfigSelector);

  const onFinish = (skills) => {
    dispatch(setJobTemplatePayload({ skills: cleanObject(skills) }));
  };

  useEffect(() => {
    form.resetFields();
    if (!isEmpty(initTemplate?.skills)) {
      form.setFieldsValue(initTemplate?.skills);
    }
  }, [form, initTemplate]);

  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <Space direction="vertical" size={24} className="w-full">
          {skills?.map((categoryItem) => (
            <TableToggle
              dataSource={categoryItem?.items}
              categoryName={categoryItem?.category}
              key={categoryItem?.category}
            />
          ))}
        </Space>
      </Form>
    </div>
  );
};

JobRequirementSkillsForm.propTypes = {
  form: PropTypes.object,
  initTemplate: PropTypes.object,
};

export default JobRequirementSkillsForm;
